import {__HERMES__} from './../../../config/api-config';
import {hermesSrpApiConfig} from '../../../config/api-config';
import {defaultFlavour, defaultRoomString} from '../../../config/app-config';
import {parseDateIntoHermesString} from '../../../utils/date-utils';
import {ISrpConfig, ISrpData} from '../redux/types';
import {IUpdate_Query} from '@stencil/hotels-common-reducer/src/types';

export interface IPrepareSRPApiRequest {
  version?: string;
  flavour?: string;
  next?: ISrpData['next'];
}

export const prepareSRPApiRequest = (
  config,
  // : ISrpConfig & IPrepareSRPApiRequest & IUpdate_Query['actionData']
) => {
  const {
    flavour = defaultFlavour,
    roomString = defaultRoomString,
    checkin,
    checkout,
    destination,
    cur,
    s,
    filter,
    // pc,
    // pcf,
    hmd = '',
    la,
    lo,
    overriderankvhids,
    next = '',
    ibp = '',
    vendor = '',
    numberOfHotels,
  } = config;
  let cityId = '';
  const {_id: destinationCityId, xtr = {}, ct = {}} = destination;
  cityId = destinationCityId;

  if (xtr && xtr.flt) {
    const {_id: voyCityId} = ct;
    cityId = voyCityId;
  }

  const {pc, pcf, ...restOfFilters} = filter;

  let url = `${__HERMES__}`;
  const checkinDateForHermes = parseDateIntoHermesString(checkin.date);
  const checkoutDateForHermes = parseDateIntoHermesString(checkout.date);

  const isPc = pc ? `&pc=${pc}` : '';
  const isPcf = pcf ? `&pcf=${pcf}` : '';
  const isNext = next ? `&next=${next}` : '';
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  const srpData = `${isNext}${isHmd}`;
  const isPs = numberOfHotels && typeof numberOfHotels === 'number' ? `&ps=${numberOfHotels}` : '';
  let isFilter = '';

  if (restOfFilters && Object.keys(restOfFilters).length > 0) {
    isFilter = `&f=${encodeURIComponent(JSON.stringify(restOfFilters))}`;
  }

  const isCur = cur ? `&cur=${cur}` : '';
  const isLatitude = la ? `&la=${la}` : '';
  const isLongitude = lo ? `&lo=${lo}` : '';
  const hasVendor = vendor ? `&vendor=${vendor}` : '';
  const hasIbp = ibp ? `&ibp=${ibp}` : '';
  const hasOverriderankvhids = overriderankvhids ? `&overriderankvhids=${overriderankvhids}` : '';
  url += `/hotels/${hermesSrpApiConfig.version}/search/data/${flavour}/${cityId}/${checkinDateForHermes}/${checkoutDateForHermes}/${roomString}`;
  url += `?s=${s}`;
  url += `${isCur}${isFilter}${isLatitude}${isLongitude}${isPc}${isPcf}${srpData}${hasOverriderankvhids}${isPs}&tmz=${checkin.date.getTimezoneOffset()}${hasVendor}${hasIbp}`;

  return url;
};
